import { Component, Input } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ProductCriteria, ProductDao } from '@app/dao/product/product.dao';

@Component({
    selector: 'pr-input-product',
    templateUrl: './pr-input-product.component.html',
    styleUrls: ['./pr-input-product.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputProductComponent,
        },
    ],
    standalone: false
})
export class PrInputProductComponent implements ControlValueAccessor {
  @Input() formControlName: string;
  @Input() derrors: boolean = false;

  @Input() label: string;
  @Input() criteria: ProductCriteria;

  options: Array<{ id: Number[]; label: string }> = [];

  values: Number[] = [];
  touched = false;
  disabled = false;
  onChange = values => {};
  onTouched = () => {};

  constructor(
    private productDao: ProductDao,
    private controlContainer: ControlContainer,
  ) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  search(term?: string) {
    let criteria = { ...this.criteria };
    if (term) criteria.autocomplete = term;
    this.productDao.getProducts(criteria).subscribe(products => {
      this.options = products.map(p => {
        return { id: p.id, label: p.name };
      });
    });
  }

  ngOnInit() {
    this.search();
  }

  onInputChange($event) {
    this.values = $event.value;
    this.onChange(this.values);
  }

  writeValue(values: Number[]): void {
    this.values = values;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  compareFn(a, b): boolean {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let item of a) {
      if (b.indexOf(item) < 0) return false;
    }
    return true;
  }
}
